import { post } from '@/config/http.js';
import storage from "@/utils/storage";
import routerIndex from "@/router";

// 获取问卷弹窗配置及问卷信息
export const getPopupSurvey = (p = {}) => post('api.getpopupsurvey.Survey', p);

// 获取个人中心专属问卷信息
export const getUserCenterSurvey = (p = {}) => post('api.getusercentersurvey.Survey', p);

// 获取问卷详情
export const getSurveyDetail = (p = {}) => {
    let userToken = storage.get("userToken");
    if (userToken) {
        p.token = userToken;
    }
    return post('api.getsurveydetail.Survey', p);
};

// 提交问卷
export const submitSurvey = (p = {}) => {
    let userToken = storage.get("userToken");
    if (!userToken || userToken === '') {
        routerIndex.push('/login');
        return Promise.reject({ status: false, msg: "未登录" });
    }
    p.token = userToken;
    return post('api.submitsurvey.Survey', p);
};

// 领取问卷商品奖励
export const deliverGoods = (p = {}) => {
    let userToken = storage.get("userToken");
    if (!userToken || userToken === '') {
        return Promise.reject({ status: false, msg: "未登录" });
    }
    p.token = userToken;
    return post('api.delivergoods.Survey', p);
};
